import React from "react";
import api from "@api";
import "./BracketTeamAdmin.css";

export default function BracketTeamAdmin({
 match,
 existingGame,
 games,
 draggedTeam,
 setDraggedTeam,
 division,
 bracketData,
 setBracketData,
 fetchGames,
 setGames,
 isTeamAlreadyPlaced,
 gameHasScore,
 setEditGame,
 setIsEditModalOpen,
 handleDeleteGame,
}) {
 if (!match) return null;
 const scoreA =
  existingGame?.score_home ?? existingGame?.score_team1 ?? null;
 const scoreB =
  existingGame?.score_away ?? existingGame?.score_team2 ?? null;

 const hasScore = scoreA != null && scoreB != null;

 const teamALost = hasScore && scoreA < scoreB;
 const teamBLost = hasScore && scoreB < scoreA;
 const getBracketSeedLabel = (team) => {
  if (!team) return "";

  if (typeof team._originalSlot === "number") {
   return `(${team._originalSlot + 1}) `;
  }

  if (team._slotLabel) {
   const seedNumber = team._slotLabel.replace("Slot ", "");
   return `(${seedNumber}) `;
  }
  return "";
 };

 const getDisplayTeamName = (team) => {
  if (!team) return "TBD";

  if (!team.slt_id) return "TBD";

  if (!team.name || team.name === "TBD") return "TBD";

  if (team.name.startsWith("Slot")) return "TBD";

  return team.name;
 };





 return (
  <div className="bracket-admin-container">

   {/* TEAM A */}
   <span
    draggable
    className={
     "bracket-admin-team " +
     (teamALost ? "team-lost " : "") +
     (!match.teamA?.name ? "bracket-admin-team-empty" : "")
    }

    onDragStart={(e) => {
     e.stopPropagation();
     setDraggedTeam({
      matchId: match.matchId,
      slot: "home",
      teamId: match.teamA?.slt_id,
     });
    }}
    onDragOver={(e) => e.preventDefault()}
    onDrop={async (e) => {
     e.preventDefault();
     const slot = "teamA";

     // 🔄 SWAP
     if (draggedTeam) {
      if (!division?.bracket_json) {
       alert("Please create and save the bracket first.");
       return setDraggedTeam(null);
      }

      if (
       gameHasScore(games, draggedTeam.matchId) ||
       gameHasScore(games, match.matchId)
      ) {
       alert("Cannot swap — one or both games already have scores.");
       return setDraggedTeam(null);
      }

      try {
       const { data } = await api.put(
        `/api/divisions/${division.id}/swapTeams`,
        {
         sourceMatchId: draggedTeam.matchId,
         targetMatchId: match.matchId,
         sourceSlot: draggedTeam.slot,
         targetSlot: "home",
        }
       );

       if (data.bracket_json) setBracketData(data.bracket_json);
       const refreshed = await fetchGames(
        division.season_id,
        division.id
       );
       setGames(refreshed);
      } catch (err) {
       console.error(err);
       alert("Swap failed");
      } finally {
       setDraggedTeam(null);
      }

      return;
     }

     // 🟡 Assign team
     const team_id = e.dataTransfer.getData("team_id");
     const team_name = e.dataTransfer.getData("team_name");
     const team_position = e.dataTransfer.getData("team_position");

     const slotObj = match[slot];
     const isWinnerSlot = !!slotObj?.sourceMatchId;

     if (isWinnerSlot) {
      alert("This is a winner slot. Teams advance here automatically after winning a previous match.");
      return;
     }

     if (team_id && team_name) {
      if (isTeamAlreadyPlaced(team_id, bracketData)) {
       alert("This team is already placed in the bracket.");
       return;
      }

      const hasRealTeam =
       match.teamA &&
       match.teamA.name &&
       match.teamA.name !== "TBD" &&
       !match.teamA.name.startsWith("Slot");

      if (hasRealTeam) {
       alert("This slot already has a team.");
       return;
      }

      try {
       const { data } = await api.put(
        `/api/divisions/${division.id}/assignTeamToSlot`,
        {
         matchId: match.matchId,
         slot: "teamA",
         team_id,
         team_name,
         position: team_position,
        }
       );
       if (data.bracket_json) setBracketData(data.bracket_json);
      } catch (err) {
       console.error("Error assigning team:", err);
       alert("Failed to assign team.");
      }
     }
    }}
   >
    {getBracketSeedLabel(match.teamA)}
    {getDisplayTeamName(match.teamA)}
   </span>

   {/* VS */}
   <span className="bracket-admin-vs">vs</span>

   {/* TEAM B */}
   <span
    draggable
    className={
     "bracket-admin-team " +
     (teamBLost ? "team-lost " : "") +
     (!match.teamB?.name ? "bracket-admin-team-empty" : "")
    }

    onDragStart={(e) => {
     e.stopPropagation();
     setDraggedTeam({
      matchId: match.matchId,
      slot: "away",
      teamId: match.teamB?.slt_id,
     });
    }}
    onDragOver={(e) => e.preventDefault()}
    onDrop={async (e) => {
     e.preventDefault();
     const slot = "teamB";

     // 🔄 SWAP
     if (draggedTeam) {
      if (!division?.bracket_json) {
       alert("Create & save bracket first.");
       return setDraggedTeam(null);
      }

      if (
       gameHasScore(games, draggedTeam.matchId) ||
       gameHasScore(games, match.matchId)
      ) {
       alert("Cannot swap — game(s) already have scores.");
       return setDraggedTeam(null);
      }

      try {
       const { data } = await api.put(
        `/api/divisions/${division.id}/swapTeams`,
        {
         sourceMatchId: draggedTeam.matchId,
         targetMatchId: match.matchId,
         sourceSlot: draggedTeam.slot,
         targetSlot: "away",
        }
       );
       if (data.bracket_json) setBracketData(data.bracket_json);
       const refreshed = await fetchGames(
        division.season_id,
        division.id
       );
       setGames(refreshed);
      } catch (err) {
       console.error(err);
       alert("Swap failed");
      } finally {
       setDraggedTeam(null);
      }

      return;
     }

     // 🟡 Assign new team
     const team_id = e.dataTransfer.getData("team_id");
     const team_name = e.dataTransfer.getData("team_name");
     const team_position = e.dataTransfer.getData("team_position");

     const slotObj = match[slot];
     const isWinnerSlot = !!slotObj?.sourceMatchId;

     if (isWinnerSlot) {
      alert("This is a winner slot. Teams advance here automatically after winning a previous match.");
      return;
     }

     if (team_id && team_name) {
      if (isTeamAlreadyPlaced(team_id, bracketData)) {
       alert("This team is already placed.");
       return;
      }

      const hasRealTeam =
       match.teamB &&
       match.teamB.name &&
       match.teamB.name !== "TBD" &&
       !match.teamB.name.startsWith("Slot");

      if (hasRealTeam) {
       alert("This slot already has a team.");
       return;
      }

      try {
       const { data } = await api.put(
        `/api/divisions/${division.id}/assignTeamToSlot`,
        {
         matchId: match.matchId,
         slot: "teamB",
         team_id,
         team_name,
         position: team_position,
        }
       );
       if (data.bracket_json) setBracketData(data.bracket_json);
      } catch (err) {
       console.error("Error assigning team:", err);
       alert("Failed to assign team.");
      }
     }
    }}
   >
    {getBracketSeedLabel(match.teamB)}
    {getDisplayTeamName(match.teamB)}
   </span>

   {/* ADMIN BUTTONS */}
   {existingGame && (
    <span className="bracket-admin-buttons">
     <button
      className="bracket-admin-edit-btn"
      onClick={(e) => {
       e.stopPropagation();
       setEditGame({ ...existingGame });
       setIsEditModalOpen(true);
      }}
     >
      ✏️
     </button>

     <button
      className="bracket-admin-delete-btn"
      onClick={(e) => {
       e.stopPropagation();
       handleDeleteGame(existingGame.id);
      }}
     >
      🗑️
     </button>
    </span>
   )}
  </div>
 );
}
